/**
 * Relay for Empty State
 */

import { graphql as gql } from 'react-relay';
const graphql = gql;

export const EmptyStateQuery = graphql`
  query emptyState_Query($license_params: [LicenseUsageParamsInput]) {
    viewer {
      ...emptyState_viewer
    }
  }
`;

export const EmptyStateFragment = graphql`
  fragment emptyState_viewer on Viewer {
    home_page(license_params: $license_params){
      featured_artist_tracks{
        id
        title
        slug
        price
        assets{
          ...assetNode @relay(mask: false)
        }
        artist{
          name
          slug
          bio
          assets{
            ...assetNode @relay(mask: false)
          }
        }
        terms{
          edges{
            node{
              id
              is_highlighted
              name
              parent_id
              taxonomy{
                id
                name
              }
            }
          }
        }
      }
      featured_collections{
        id
        description
        name
        slug
        category {
          id
          name
        }
        assets{
          ...assetNode @relay(mask: false)
        }
      }
      featured_tracks{
        id
        title
        slug
        price
        assets{
          ...assetNode @relay(mask: false)
        }
        artist{
          name
          slug
          assets{
            ...assetNode @relay(mask: false)
          }
        }
        terms{
          edges{
            node{
              id
              is_highlighted
              name
              parent_id
              taxonomy{
                id
                name
              }
            }
          }
        }
      }
      featured_terms{
        name
        items{
          ... on TaxonomyTerm {
            ...termNode @relay(mask: false)
          }
          ... on HomePageLink {
            title
            url
          }
        }
      }
      header_posts {
        title
        subtitle
        post_url
        image_url
      }
      blog_posts {
        title
        excerpt
        author
        post_url
        image_url
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/emptyState.ts